// components/ContactModal.js
// import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { X } from 'lucide-react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa6';
import React, { useRef, useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
  const form = useRef();
const [isSubmitting, setIsSubmitting] = useState(false);
const [success, setSuccess] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  emailjs
    .sendForm(
      'service_qu2di6w',
      'template_nou98qo',
      form.current,
      'bFPKHJE_ydPHb4XZE'
    )
    .then(() => {
      setIsSubmitting(false);
      setSuccess(true);
      form.current.reset();
    })
    .catch((error) => {
      setIsSubmitting(false);
      alert('❌ Failed to send message. Please try again.');
      console.error(error);
    });
};


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end h-full p-4">
      <div className="bg-[#1c1c1c]/90 text-white w-full max-w-6xl p-10 rounded-lg relative overflow-y-auto max-h-screen">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-5 right-5 text-white">
          <X size={28} />
        </button>

        <h2 className="text-4xl mb-10">Contact Us</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Form */}
          <div className="md:col-span-2">
            <form ref={form} onSubmit={handleSubmit} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  name="first_name"
                  className="bg-transparent border-b outline-none border-white p-2"
                  placeholder="First Name *"
                  required
                />
                <input
                  name="last_name"
                  className="bg-transparent border-b outline-none border-white p-2"
                  placeholder="Last Name *"
                  required
                />
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  type="email"
                  name="email"
                  className="bg-transparent border-b outline-none border-white p-2"
                  placeholder="Email *"
                  required
                />
                <input
                  name="phone"
                  className="bg-transparent border-b outline-none border-white p-2"
                  placeholder="Phone"
                />
              </div>
              <textarea
                name="message"
                className="bg-transparent border-b outline-none border-white p-2 w-full"
                rows="4"
                placeholder="Message"
                required
              />
       <button
  type="submit"
  disabled={isSubmitting}
  className="mt-4 px-6 py-2 bg-[#ec2128] text-white font-bold rounded disabled:opacity-50"
>
  {isSubmitting ? 'Sending...' : 'Send Message'}
</button>

            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-6 text-sm">
            <div>
              <h4 className="font-bold">Call Us</h4>
              <p>99528 95135,<br />90251 44666</p>
            </div>
            <div>
              <h4 className="font-bold">Email Us</h4>
              <p>rdsenclave2025@gmail.com</p>
            </div>
            <div>
              <h4 className="font-bold">Our Location</h4>
              <p>
                A kaspa, to, Ahmedi Nagar, Somalapuram,<br />
                Ambur, Tamil Nadu - 635802
              </p>
            </div>
            <div>
              <h4 className="font-bold">Connect with Us</h4>
              <div className="flex space-x-4 mt-2 text-xl">
                <FaFacebookF />
                <FaTwitter />
                <FaInstagram />
                <FaYoutube />
              </div>
            </div>
            {/* Success Modal */}
{success && (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
    <div className="bg-white text-black p-6 rounded-xl shadow-lg max-w-md text-center">
      <h3 className="text-2xl font-bold mb-2">✅ Message Sent!</h3>
      <p className="mb-4">We’ve received your message. We'll get back to you shortly.</p>
      <button
        onClick={() => {
          setSuccess(false);
          onClose();
        }}
        className="bg-[#ec2128] text-white px-4 py-2 rounded"
      >
        Close
      </button>
    </div>
  </div>
)}

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
